<template>
    <div class="user-detail">
        <NameCard :uuid="uuid" :show-edit="!uuid"/>

        <van-cell-group class="user-info round-corner">
            <van-cell title="职位" :value="user.orgName"/>
            <van-cell title="办公电话" :value="user.telOffice"/>
            <van-cell title="家庭电话" :value="user.telHome"/>
            <van-cell title="电子邮件" :value="user.email"/>
        </van-cell-group>

        <van-form @submit="onSubmit" class="user-setting-form" v-if="!uuid">
            <h3 class="form-title">公开电话给下列人员</h3>
            <div class="round-corner">
                <van-field name="switch" label="教师" input-align="right">
                    <template #input>
                        <van-switch v-model="tel.teacher" size="20"/>
                    </template>
                </van-field>
                <van-field name="switch" label="学生" input-align="right">
                    <template #input>
                        <van-switch v-model="tel.student" size="20"/>
                    </template>
                </van-field>
                <van-field name="switch" label="其它" input-align="right">
                    <template #input>
                        <van-switch v-model="tel.other" size="20"/>
                    </template>
                </van-field>
            </div>
            <div style="margin: 16px;">
                <van-button round block  type="info" native-type="submit">
                    保存设置
                </van-button>
            </div>
        </van-form>

    </div>
</template>

<script>
import {Cell, CellGroup, Form, Switch, Field, Button, Toast} from 'vant'
import NameCard from "@/components/NameCard/NameCard";
import {queryUser} from "@/api";
import {saveUserSetting} from "@/api/address-book";

export default {
    name: 'UserDetail',
    components: {
        NameCard,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Form.name]: Form,
        [Switch.name]: Switch,
        [Field.name]: Field,
        [Button.name]: Button,
    },
    props: ['uuid'],
    data() {
        return {
            user: {},
            tel: {
                teacher: true,
                student: true,
                other: true,
            },
        }
    },
    computed: {},
    methods: {
        onSubmit() {
            saveUserSetting({
                userId: this.user.userId,
                setting: {tel: Object.keys(this.tel).filter(key => this.tel[key])}
            }).then(resp => {
                if (resp && resp.code == '200'){
                    Toast.success('保存成功')
                } else {
                    Toast.fail('保存失败')
                }
            }).catch(error => Toast.fail('服务器繁忙或网络异常，请稍后重试'))
        },
    },
    created() {
        queryUser(this.uuid)
            .then(user => {
                this.user = user
                if (user && user.setting && user.setting.tel)
                    Object.keys(this.tel).forEach(key => this.tel[key] = user.setting.tel.includes(key))
            })
            .catch(error => Toast.fail('服务器繁忙或网络异常，请稍后重试'))
    }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
.user-detail {
    .user-info {
        margin: 0 15px;
    }

    .user-setting-form {
        margin: 10px 15px;
    }

    .form-title {
        color: #666;
        font-weight:400;
        padding: 10px 0;
        @extend .font14;
    }

}
</style>
